import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { createAction } from 'redux-actions';
export const fetchGruserSuccess = createAction('@@gruser.GRUSER.FETCH.SUCCESS', (payload)=>_object_spread({}, payload));
